/* eslint no-param-reassign: "off" */
import moment from 'moment';
import * as types from './mutation-types';

export default {
  [types.CREATE_SOCIAL_POST_REQUEST]: state => {
    state.createSocialPostRequest = true;
    state.createSocialPostSuccess = false;
    state.createSocialPostFailed = false;
    state.createSocialPostErrors = null;
    state.post = null;
  },

  [types.CREATE_SOCIAL_POST_SUCCESS]: state => {
    state.createSocialPostRequest = false;
    state.createSocialPostSuccess = true;
    state.createSocialPostFailed = false;
  },

  [types.CREATE_SOCIAL_POST_FAILURE]: (state, error) => {
    state.createSocialPostRequest = false;
    state.createSocialPostSuccess = false;
    state.createSocialPostFailed = true;
    state.createSocialPostError = error;
  },

  [types.GET_SCHEDULED_MESSAGES_REQUEST]: state => {
    state.getScheduledMessagesRequest = true;
    state.getScheduledMessagesSuccess = false;
    state.getScheduledMessagesFailed = false;
    state.getScheduledMessagesErrors = null;
  },

  [types.GET_SCHEDULED_MESSAGES_SUCCESS]: (state, data) => {
    state.getScheduledMessagesRequest = false;
    state.getScheduledMessagesSuccess = true;
    state.getScheduledMessagesFailed = false;
    state.scheduledMessages = data;
  },

  [types.GET_SCHEDULED_MESSAGES_FAILURE]: (state, errors) => {
    state.getScheduledMessagesRequest = false;
    state.getScheduledMessagesSuccess = false;
    state.getScheduledMessagesFailed = true;
    state.getScheduledMessagesErrors = errors;
  },

  [types.DELETE_SCHEDULED_MESSAGE_REQUEST]: state => {
    state.deleteScheduledMessageRequest = true;
    state.deleteScheduledMessageSuccess = false;
    state.deleteScheduledMessageFailed = false;
    state.deleteScheduledMessageErrors = null;
  },

  [types.DELETE_SCHEDULED_MESSAGE_SUCCESS]: (state, id) => {
    state.deleteScheduledMessageRequest = false;
    state.deleteScheduledMessageSuccess = true;
    state.deleteScheduledMessageFailed = false;
    state.scheduledMessages.splice(state.scheduledMessages.findIndex(x => x.id === id), 1);
  },

  [types.DELETE_SCHEDULED_MESSAGE_FAILURE]: (state, errors) => {
    state.deleteScheduledMessageRequest = false;
    state.deleteScheduledMessageSuccess = false;
    state.deleteScheduledMessageFailed = true;
    state.deleteScheduledMessageErrors = errors;
  },

  [types.UPDATE_SCHEDULED_MESSAGE_REQUEST]: state => {
    state.updateScheduledMessageRequest = true;
    state.updateScheduledMessageSuccess = false;
    state.updateScheduledMessageFailed = false;
    state.updateScheduledMessageErrors = null;
  },

  [types.UPDATE_SCHEDULED_MESSAGE_SUCCESS]: (state, data) => {
    state.updateScheduledMessageRequest = false;
    state.updateScheduledMessageSuccess = true;
    state.updateScheduledMessageFailed = false;

    const updated = {
      media: data.media || [],
      channels: data.channelIds || [],
      message: data.message || '',
      post_date: data.scheduleTimestamp
        ? moment(data.scheduleTimestamp * 1000).format('YYYY-MM-DDTHH:mm:ss')
        : null,
      id: data.id,
    };

    const idx = state.scheduledMessages.findIndex(x => x.id === data.id);

    if (updated.post_date) {
      state.scheduledMessages.splice(idx, 1, updated);
    } else {
      state.scheduledMessages.splice(idx, 1);
    }
  },

  [types.UPDATE_SCHEDULED_MESSAGE_FAILURE]: (state, error) => {
    state.updateScheduledMessageRequest = false;
    state.updateScheduledMessageSuccess = false;
    state.updateScheduledMessageFailed = true;
    state.updateScheduledMessageErrors = error;
  },

  [types.EDITING_SOCIAL_POST]: (state, post) => {
    state.isEditing = true;
    state.post = post;
  },

  [types.CREATING_SOCIAL_POST]: (state, post) => {
    state.isEditing = false;
    state.post = post;
  },

  [types.SET_SELECTED_FACEBOOK_PAGE]: (state, pageId) => {
    state.selectedFacebookPage = pageId;
  },

  [types.SET_SELECTED_INSTAGRAM_PAGE]: (state, pageId) => {
    state.selectedInstagramPage = pageId;
  },

  [types.SET_FACEBOOK_PAGES]: (state, pages) => {
    state.facebookPages = pages;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/social/mutations.js